<div class="button-wrapper" *ngIf="backButtonText?.length && backButtonValue !== MpeDialogPage.NONE">
  <button id="back-button" mat-button (click)="onBackButtonClick()" class="flat">{{backButtonText}}</button>
</div>
<div class="button-wrapper">
  <button [ngClass]= "!nextButtonEnable ? 'disabled-next-button' : 'next-button'" mat-raised-button class="raised"
          [disabled]= !nextButtonEnable (click)="onNextButtonClick()">{{nextButtonText}}</button>
</div>
